module.exports = __webpack_public_path__ + "img/chapmanr.7b143b7b.jpg";